(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kash-home-desktop"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '.kash-home-hero__video';

  const attemptPlayback = (video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;

    const playback = video.play();
    if (playback && typeof playback.catch === 'function') {
      playback.catch(() => {});
    }
  };

  const playHeroVideos = () => {
    document.querySelectorAll(selector).forEach((video) => {
      attemptPlayback(video);

      if (!video.dataset.kashAutoplayRetryBound) {
        video.dataset.kashAutoplayRetryBound = 'true';
        video.addEventListener('loadeddata', () => attemptPlayback(video), { once: true });
        video.addEventListener('canplay', () => attemptPlayback(video), { once: true });
      }
    });
  };

  if (!window.__kashDesktopHeroAutoplayBound) {
    window.__kashDesktopHeroAutoplayBound = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', playHeroVideos, { once: true });
    } else {
      playHeroVideos();
    }

    window.addEventListener('load', playHeroVideos, { once: true });
    window.addEventListener('pageshow', playHeroVideos);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) playHeroVideos();
    });
    document.addEventListener('shopify:section:load', playHeroVideos);
    document.addEventListener('shopify:section:select', playHeroVideos);
  } else {
    playHeroVideos();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kash-home-mobile"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-kash-mobile-video]';

  const startVideo = (video) => {
    if (!(video instanceof HTMLVideoElement)) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    const playback = video.play();
    if (playback && typeof playback.catch === 'function') {
      playback.catch(() => {});
    }
  };

  const startAllVideos = () => {
    document.querySelectorAll(selector).forEach((video) => {
      if (!video.dataset.kashAutoplayBound) {
        video.dataset.kashAutoplayBound = 'true';
        video.addEventListener('loadedmetadata', () => startVideo(video));
        video.addEventListener('canplay', () => startVideo(video));
      }

      startVideo(video);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startAllVideos, { once: true });
  } else {
    startAllVideos();
  }

  window.addEventListener('pageshow', startAllVideos);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) startAllVideos();
  });
  document.addEventListener('shopify:section:load', startAllVideos);

  if (!window.__kashMobileAutoplayFallbackBound) {
    window.__kashMobileAutoplayFallbackBound = true;
    document.addEventListener('touchstart', startAllVideos, { once: true, passive: true });
    document.addEventListener('pointerdown', startAllVideos, { once: true, passive: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kash-submenu-timing"]) return;
  try {
    
(() => {
  if (window.__kashSubmenuZeroFlashBound) return;
  window.__kashSubmenuZeroFlashBound = true;

  const selector = '.section-header header-drawer .menu-drawer__navigation summary.menu-drawer__menu-item';

  document.addEventListener(
    'click',
    (event) => {
      const summary = event.target.closest(selector);
      if (!summary) return;

      const details = summary.parentElement;
      const submenu = summary.nextElementSibling;

      if (!details || details.tagName !== 'DETAILS') return;
      if (!submenu?.classList.contains('menu-drawer__submenu')) return;
      if (details.hasAttribute('open')) return;

      /*
       * Stop Dawn's delayed submenu opener. We apply the entire open state in this same
       * event task, before Safari can paint an intermediate [open]-only frame.
       */
      event.preventDefault();
      event.stopPropagation();

      const parentMenu = details.closest('.menu-drawer__menu.has-submenu');
      const branchItem = details.parentElement;

      parentMenu?.classList.add('kash-submenu-switching');

      if (branchItem) {
        branchItem.style.setProperty('transition', 'none', 'important');
        branchItem.style.setProperty('-webkit-transition', 'none', 'important');
        branchItem.style.setProperty('transform', 'none', 'important');
        branchItem.style.setProperty('-webkit-transform', 'none', 'important');
      }

      details.setAttribute('open', '');
      details.classList.add('menu-opening');
      summary.setAttribute('aria-expanded', 'true');
      parentMenu?.classList.add('submenu-open');
      parentMenu?.classList.remove('kash-submenu-switching');

      const closeButton = submenu.querySelector(':scope > .menu-drawer__inner-submenu > .menu-drawer__close-button');
      if (typeof trapFocus === 'function' && closeButton) {
        requestAnimationFrame(() => {
          try {
            trapFocus(submenu, closeButton);
          } catch (_) {}
        });
      }
    },
    true
  );
})();

  } catch(e) { console.error(e); }
})();
})();
